import { create } from 'zustand';

interface ViewingCamerasState {
  /** deviceId → reference count (supports same camera in multiple panes) */
  viewingDeviceIds: Map<string, number>;
  registerViewing: (deviceId: string) => void;
  unregisterViewing: (deviceId: string) => void;
  isViewing: (deviceId: string) => boolean;
}

export const useViewingCamerasStore = create<ViewingCamerasState>((set, get) => ({
  viewingDeviceIds: new Map(),

  registerViewing: (deviceId: string) => {
    set((state) => {
      const next = new Map(state.viewingDeviceIds);
      next.set(deviceId, (next.get(deviceId) ?? 0) + 1);
      return { viewingDeviceIds: next };
    });
  },

  unregisterViewing: (deviceId: string) => {
    set((state) => {
      const next = new Map(state.viewingDeviceIds);
      const count = (next.get(deviceId) ?? 1) - 1;
      if (count <= 0) {
        next.delete(deviceId);
      } else {
        next.set(deviceId, count);
      }
      return { viewingDeviceIds: next };
    });
  },

  isViewing: (deviceId: string) => {
    return (get().viewingDeviceIds.get(deviceId) ?? 0) > 0;
  },
}));
